import { getAuthHeaders } from './authHeader';
import { isProRequired, notifyProRequired, proRequiredError } from './proRequired';

const BASE_URL = process.env.NEXT_PUBLIC_SERVER_URL;

// The backend works out whose bookmarks these are from the signed-in user's
// token (Authorization header), so no user id is ever sent.

export const bookmarkAPI = {
	async getBookmarks() {
		const response = await fetch(
			`${BASE_URL}bookmarks/user`,
			{ cache: 'no-store', headers: await getAuthHeaders() }
		);
		// Not Pro (any more): treat as having none rather than failing.
		if (isProRequired(response)) {
			notifyProRequired();
			return { bookmarks: [] };
		}
		if (!response.ok) throw new Error('Failed to fetch bookmarks');
		return response.json();
	},

	async addBookmark(messageId) {
		const response = await fetch(`${BASE_URL}bookmarks/add`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				...(await getAuthHeaders()),
			},
			body: JSON.stringify({ messageId }),
		});
		if (isProRequired(response)) throw proRequiredError();
		if (!response.ok) throw new Error('Failed to add bookmark');
		return response.json();
	},

	async removeBookmark(messageId) {
		const response = await fetch(`${BASE_URL}bookmarks/remove`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				...(await getAuthHeaders()),
			},
			body: JSON.stringify({ messageId }),
		});
		if (isProRequired(response)) throw proRequiredError();
		if (!response.ok) throw new Error('Failed to remove bookmark');
		return response.json();
	},

	async getMessagesAPI(messageIds) {
		const idsParam = messageIds.join(',');
		const response = await fetch(
			`${BASE_URL}messages/search?priorityIds=${idsParam}&size=${messageIds.length}`,
			{ cache: 'no-store', headers: await getAuthHeaders() }
		);
		if (!response.ok) throw new Error('Failed to fetch messages');
		return response.json();
	},
};